<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="legend-item-container">
  @for (item of legendItems(); track $index) {
    <span
      class="legend-item"
      [class.faded]="
        isAllItemsHidden() ||
        isLegendItemHidden(item) ||
        ((highlightedLegendItemIndex() || highlightedLegendItemIndex() === 0) &&
          highlightedLegendItemIndex() !== $index)
      "
      (mouseenter)="
        legendItemMouseEnter.emit(item); highlightedLegendItemIndex.set($index)
      "
      (mouseleave)="
        legendItemMouseLeave.emit(item); highlightedLegendItemIndex.set(null)
      "
      [style.cursor]="isLegendItemHidden(item) ? 'pointer' : 'default'"
      (click)="legendItemClick.emit(item)"
    >
      @switch (item.symbol) {
        @case ('bar') {
          <div class="bar-icon" [style.background-color]="item.color"></div>
        }
        @case ('line') {
          <div class="line-icon" [style.background-color]="item.color"></div>
        }
        @default {
          <i class="material-symbols-rounded" [style.color]="item.color">{{
            item.symbol
          }}</i>
        }
      }
      {{ item.name }}
    </span>
  }
</div>
